import { Check, Lock } from "lucide-react";

export const STEPS = [
  { key: "history", label: "History", num: 1 },
  { key: "questions", label: "Questions", num: 2 },
  { key: "provisional", label: "Provisional Dx", num: 3 },
  { key: "investigations", label: "Investigations", num: 4 },
  { key: "final", label: "Final Diagnosis", num: 5 },
  { key: "care_plan", label: "Care Plan", num: 6 },
  { key: "follow_up", label: "Follow-up", num: 7 },
  { key: "visits", label: "Visits & Prognosis", num: 8 },
];

export const ORDER = STEPS.map((s) => s.key);

export default function Timeline({ reachedIdx, active, onSelect }) {
  return (
    <nav className="flex flex-col gap-1" data-testid="journey-timeline">
      {STEPS.map((s, i) => {
        const done = i < reachedIdx;
        const current = s.key === active;
        const reachable = i <= reachedIdx;
        return (
          <button
            key={s.key}
            data-testid={`timeline-step-${s.key}`}
            disabled={!reachable}
            onClick={() => reachable && onSelect(s.key)}
            className={`group flex items-center gap-3 rounded-md px-3 py-2.5 text-left transition-colors ${
              current
                ? "bg-primary text-primary-foreground"
                : reachable
                ? "text-foreground hover:bg-muted"
                : "cursor-not-allowed text-muted-foreground/50"
            }`}
          >
            <span
              className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border text-xs font-semibold ${
                current
                  ? "border-primary-foreground bg-primary-foreground text-primary"
                  : done
                  ? "border-primary bg-primary text-primary-foreground"
                  : reachable
                  ? "border-border bg-card text-foreground"
                  : "border-border bg-muted text-muted-foreground/60"
              }`}
            >
              {done ? <Check className="h-3.5 w-3.5" /> : reachable ? s.num : <Lock className="h-3 w-3" />}
            </span>
            <span className="text-sm font-medium">{s.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
